import {header} from "./modules/header.js";
import Lenis from '@studio-freight/lenis';
import {heroHome} from "./modules/hero-home.js";
import {contacts} from "./modules/contacts.js";
import {map} from "./modules/map.js";
import AOS from 'aos';
import {heroAbout} from "./modules/heroAbout.js";
import {history} from "./modules/history.js";
import {heroSubcategory} from "./modules/hero-subcategory.js";
import {ourGallery} from "./modules/ourGallery.js";
import {productFeatures} from "./modules/product-features.js";
import {ourSolutions} from "./modules/ourSolutions.js";
import {ourAdvantages} from "./modules/ourAdvantages.js";
import {oem} from "./modules/oem.js";
import {rangeSection} from "./modules/range.js";
import {superSection} from "./modules/super.js";
import {linesSection} from "./modules/lines.js";
import {heroProduct} from "./modules/hero-product.js";

document.addEventListener("DOMContentLoaded", (event) => {
    AOS.init({
        once: true,
        duration: 1000,
        disable: function() {
            return window.innerWidth < 768; // Отключает анимации для экранов меньше 768px
        }
    });
    //the scripts you need on the first screen.

    let scriptLaunchStart = true;
    //this function is called once, after a user interaction.
    const scriptLaunch = () => {
        /*the rest of the scripts, for example:
         * working with bibilio libraries, sliders, etc.
         */

    }
    if (window.pageYOffset >= 1 && scriptLaunchStart) {
        scriptLaunchStart = false;
        scriptLaunch();
    } else if (window.pageYOffset < 1 && scriptLaunchStart) {
        const events = ['mousemove', 'click', 'mousewheel', 'scroll', 'touchstart', 'keydown', 'keypress', 'mouseover', 'mouseout', 'resize'];
        events.forEach(event => {
            window.addEventListener(event, () => {
                if (scriptLaunchStart) {
                    scriptLaunchStart = false;
                    scriptLaunch();
                }
            });
        });
    }

    const lenis = new Lenis({
        duration: .6,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        smoothWheel: true,
        smoothTouch: false,
        wheelMultiplier: 0.65,
        touchMultiplier: 0.3,
        normalizeWheel: true,
    });

    // Робимо доступним глобально
    window.lenis = lenis;

    function raf(time) {
        lenis.raf(time)

        requestAnimationFrame(raf)
    }
    requestAnimationFrame(raf)


    let wasMobile = window.innerWidth <= 999;
    window.addEventListener('resize', () => {
        const isMobile = window.innerWidth <= 999;
        if (isMobile !== wasMobile) {
            location.reload();
        }
    });

    function observeSections(selector = 'section') {
        const sections = document.querySelectorAll(selector);

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('section-visible');
                }
            });
        }, {
            threshold: 0.1
        });

        sections.forEach(section => observer.observe(section)); // ✅
    }

    observeSections();

    function observeSections2(selector = '[data-section]') {
        const sections = document.querySelectorAll(selector);

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('section-visible');
                }
            });
        }, {
            threshold: 1
        });

        sections.forEach(section => observer.observe(section)); // ✅
    }

    observeSections2();


    header()
    heroHome()
    contacts()
    map()
    heroAbout()
    history()
    heroSubcategory()
    ourGallery()
    productFeatures()
    ourSolutions()
    ourAdvantages()
    oem()
    rangeSection()
    superSection()
    linesSection()
    heroProduct()
});